import React, { useState } from "react";
import { InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { Button, Input, SubTitle } from "../../Components/CustomComponents";
import { useSendNotificationMutation } from "../../Data/services/sendNotificationApi";
import Toast from "../../Hooks/useToast";
import styles from "./styles/sendNotificationScreen.module.scss";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";

const SendNotificationScreen = ({ setPage }) => {
  const [title, setTitle] = useState("");
  const [notification, setNotification] = useState("");
  const { control, handleSubmit, watch } = useForm({ mode: "onChange" });
  const [
    sendNotification,
    { isSuccess: isSuccessAdd, isLoading: isLoadingAdd, isError: isErrorAdd },
  ] = useSendNotificationMutation();
  const role = watch("role");
  const status = watch("status");

  const optionRole = [
    { value: "coach", label: "Coach" },
    { value: "student", label: "Student" },
  ];

  const optionStatus = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const handleSendNotification = async (data) => {
    const payload = {
      title: title,
      message: notification,
      type: "admin-push",
    };
    if (role !== "") {
      payload.role = role;
    }
    if (status !== "") {
      payload.status = status;
    }

    try {
      let response = await sendNotification(payload).unwrap();
      Toast(response?.message, "success");
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };

  return (
    <div className={styles.MainContainer}>
      <div className={`${styles.headerContainer} flex-between`}>
        <div>
          <SubTitle text={"Send Notification"} />
        </div>
        <div className="d-flex align-items-center gap-2">
          <div>
            <Button
              classes={`${styles.cardBtn} `}
              text={isLoadingAdd ? <LoadingButton /> : "Send"}
              onClick={handleSendNotification}
            ></Button>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <InputGroup className="mb-3">
          <Input
            placeholder="Title"
            type="text"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
        </InputGroup>

        <InputGroup className="mb-3">
          <Input
            placeholder="Notification"
            type="textarea"
            as="textarea"
            rows={5}
            value={notification}
            onChange={(e) => {
              setNotification(e.target.value);
            }}
          />
        </InputGroup>
      </div>
    </div>
  );
};

export default SendNotificationScreen;
